import {makeGetSpecialtiesSubSpecialtiesMedicalGuide} from 'main/factories/usecases';
import {HealthSpecialtiesParams} from './types';

export async function getHealthSpecialties(params: HealthSpecialtiesParams) {
	const response = await makeGetSpecialtiesSubSpecialtiesMedicalGuide().get(params);
	if (!response.especialidades || response.especialidades.length === 0) {
		return [];
	}
	return response.especialidades;
}
